import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ExsepComponent } from './exsep.component';
import { ExpertProfileComponent } from './pages/expert-profile/expert-profile.component';


const routes: Routes = [
  {
    path: '',
    component: ExsepComponent,
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'sopra-profile' },
      { 
        path: 'sopra-profile', 
        component: ExpertProfileComponent,
        data: {
          config: {
            expertType: 'sopra',
            pageTitle: 'طلبات المتقدمين لسوبرا',
            filterPage: 'SOPRA_EXPERTS',
            statusLabel: 'حالة ملف سوبرا',
            rejectDialogTitle: 'رفض طلب ملف سوبرا'
          }
        }
      },
      { 
        path: 'ayen-profile', 
        component: ExpertProfileComponent,
        data: {
          config: {
            expertType: 'ayen',
            pageTitle: 'طلبات المتقدمين لعاين',
            filterPage: 'AYEN_EXPERTS',
            statusLabel: 'حالة ملف عاين',
            rejectDialogTitle: 'رفض طلب ملف عاين'
          }
        }
      },
      
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ExsepRoutingModule {}
